module.exports = __webpack_public_path__ + "static/media/Banner-Mobile2.0a3810c6.jpg";